import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .pf-title {
    font-family: 'Inter';
    font-weight: 500;
    font-size: 16px;
    line-height: 19.36px;
    color: #000000;
  }

  .pf-container {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0px;
    width: 70%;
    gap: 24px;
  }

  .review-img-container {
    display: flex;
    gap: 24px;
  }

  .pf-checkbox {
    display: flex;

    margin-bottom: 32px;
  }

  @media only screen and (max-width: 1440px) {
    .pf-container {
      width: 80%;
    }
  }
`
